import { observer } from "mobx-react-lite";
import * as React from "react";
import { useParams } from "react-router-dom";
import { LoaderBox } from "src/components/LoaderBox";
import { msgQueueStore } from "src/components/MsgQueue";
import { PageLayout } from "src/components/PageLayout";
import { CatalogRecordForm } from "src/pages/catalogs/CatalogRecordForm";

import { WorkflowPageTitle } from "../WfNewRecordPage/WorkflowPageTitle";
import { StepActionsDropdown } from "./StepActionsDropdown";
import {
  createWfRecordCardStore,
  WfRecordCardStore,
} from "./wfRecordCardStore";

export const WfRecordCardPage: React.FC = observer(() => {
  const { id = "" } = useParams();
  const pageStore = React.useMemo(() => {
    const store = createWfRecordCardStore();
    store.init(id);
    return store;
  }, [id]);

  return (
    <PageLayout title={pageStore.breadcrumbs}>
      <LoaderBox
        remoteData={pageStore.data}
        drawReady={() => <Inner pageStore={pageStore} />}
      />
    </PageLayout>
  );
});

const Inner: React.FC<{ pageStore: WfRecordCardStore }> = observer(
  ({ pageStore }) => {
    if (!pageStore.cdsFormStore) return null;
    return (
      <CatalogRecordForm
        store={pageStore.cdsFormStore}
        title={
          <WorkflowPageTitle
            title={pageStore.title}
            stepName={pageStore.currentStepName}
            stepDescription={pageStore.currentStepDescription}
          />
        }
        extra={<StepActionsDropdown pageStore={pageStore} />}
        okText="Сохранить"
        submit={(values) => pageStore.submit(values)}
        onSuccess={() =>
          msgQueueStore.add({
            type: "info",
            message: "Выполнено сохранение данных",
          })
        }
      />
    );
  },
);
